export default __webpack_public_path__ + "images/b0e8a686aeebeb5424db395667d0bfe2.png";